import { ApplicantService } from '@/store'
import { RouterUtils } from '@/commons/utils/router'
import { SubApplicationRoute } from '@/commons/types'
import { BASE_PATH, PathType } from '@/id-card/constants/router'

import IdCardCreate from '@/id-card/views/IdCardCreate.vue'
import IdCardSummary from '@/id-card/views/IdCardSummary.vue'
import IdCardApplicants from '@/id-card/views/IdCardApplicants.vue'

const ID_CARD_ROUTES: Array<SubApplicationRoute> = [
    {
        path: `${BASE_PATH}/applicants`,
        component: IdCardApplicants,
        meta: {
            requiresAuth: true,
            isMainNavigation: true,
            keepApplicationStore: false,
            buttonTranslationKey: 'buttonTextIdCard'
        }
    },
    {
        path: `${BASE_PATH}/create/:personCodeFromUrl`,
        component: IdCardCreate,
        name: PathType.CREATE,
        props: true,
        beforeEnter: function (to, from, next) {
            if (!RouterUtils.isApplicationKeep(to, from, PathType.SUMMARY)) {
                ApplicantService.resetApplicantStore()
            }
            next()
        },
        meta: {
            requiresAuth: true,
            keepApplicationStore: true
        }
    },
    {
        path: `${BASE_PATH}/summary/:personCodeFromUrl`,
        component: IdCardSummary,
        name: PathType.SUMMARY,
        props: true,
        beforeEnter: function (to, from, next) {
            if (!RouterUtils.isApplicationKeep(to, from, PathType.CREATE)) {
                ApplicantService.resetApplicantStore()
            }
            next(RouterUtils.setSummaryRoute(PathType.CREATE, to.params.personCodeFromUrl))
        },
        meta: {
            requiresAuth: true,
            keepApplicationStore: true
        }
    }
]

export default ID_CARD_ROUTES
